import { render, staticRenderFns } from "./rejectModal.vue?vue&type=template&id=2d33ea9a&scoped=true"
import script from "./rejectModal.vue?vue&type=script&lang=js"
export * from "./rejectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33ea9a",
  null
  
)

export default component.exports